const columns = [
  {
    title: '下载相关',
    links: ['安卓版下载', '手机版入口', '完整安装包', '最新版本'],
  },
  {
    title: '安装帮助',
    links: ['安装步骤', '更新失败排查', '解析失败解决', '权限设置'],
  },
  {
    title: '指南中心',
    links: ['图文攻略', '热门查询榜', '常见问题', '入口辨别'],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-8 lg:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-leaf-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">蘑菇视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-xs">
              专注于提供安卓版下载、手机版安装包与最新版本获取方式，帮你在最短时间内完成安装。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-smartphone-line', 'ri-download-2-line', 'ri-shield-check-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center text-background-200"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <p className="font-heading font-bold text-sm text-background-50">{col.title}</p>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#download"
                      className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-400">
            本页为蘑菇视频 APP 下载与安装指南展示页面，内容仅供参考。
          </p>
          <p className="text-xs text-background-400">© 2026 蘑菇视频下载指南</p>
        </div>
      </div>
    </footer>
  );
}